/**
 * Copy the shell itself carries, as opposed to any one portal's.
 *
 * These are the words on the frame — the identity card's verified line, the
 * switch link, the sign-out button — and they read the same whichever portal is
 * inside it. A portal's own copy lives on its `PortalSpec`.
 */
export const SHELL_COPY = {
  switchWorkspace: "Switch workspace",
  signOut: "Log out",
  verified: "Verified",
  unverified: "Not yet verified",
  /** The greeting destination's subtitle, with the reader's first name appended. */
  welcome: "Welcome back",
} as const;
